module.exports = __webpack_public_path__ + "img/anquan.4db438b2.png";